<template>

    <FloatingPanel title="Verhalen">

        <div class="canvas::blocks-modules-story-BlockPanel">

            <Tabs :tabs="[
                'Maatwerk',
                'Algemeen',
            ]">

                <div slot="Maatwerk">

                    <!-- Category Accordion (only shown if categories are enabled) -->
                    <accordion-input v-if="categoriesEnabled" :open="true">
                        <template #label>
                            <div class="font-medium text-gray-600">Categorieën</div>
                        </template>
                        <template #content>
                            <div class="mb-1 text-sm text-gray-600">Selecteer categorieën om te filteren</div>

                            <select
                                v-model="options.categories"
                                multiple
                                class="w-full px-3 py-2 mt-1 transition duration-150 ease-in-out border border-gray-300 border-solid rounded-md shadow-sm focus:border-blue-300 focus:outline-none focus:shadow-outline-blue form-control form-input sm:leading-5 sm:text-sm"
                                style="min-height: 120px;"
                            >
                                <option value="">Alles</option>
                                <option v-for="category in categories" :key="category.id" :value="category.id">
                                    {{ category.name }}
                                </option>
                            </select>
                        </template>
                    </accordion-input>

                    <SwitchInput
                        label="Toon paginatie"
                        instruction="Bepaal hier of de paginatie moet worden getoond."
                        :options="options"
                        options-property="show_pagination"
                        :items="[
                            { value: '1', label: 'Ja'},
                            { value: '0', label: 'Nee'},
                        ]"
                        defaultValue="0"
                    />

                    <TextInput
                        label="Paginatie aantal"
                        instruction="Bepaal hier het aantal items per pagina."
                        :options="options"
                        options-property="pagination_amount"
                        :open="false"
                    />

                    <SwitchInput
                        label="Mobiele slider"
                        instruction="Toon items als slider op mobiel"
                        :options="options"
                        options-property="showMobileSlider"
                        :items="[
                            { value: 1, label: 'Aan'},
                            { value: 0, label: 'Uit'},
                        ]"
                        :defaultValue="1"
                    />

                </div>
                    

                <div slot="Algemeen">

                    <CommonInputs
                        :options="options"
                    />

                </div>

            </Tabs>

        </div>

    </FloatingPanel>

</template>

<script>

import Tabs from "@galaxy/modules/Canvas/resources/js/editor/website/editors/panels/Tabs";
import AbstractPanel from '@galaxy/modules/Canvas/resources/js/editor/website/editors/AbstractPanel';
import FloatingPanel from '@galaxy/modules/Canvas/resources/js/editor/website/editors/panels/FloatingPanel';
import CommonInputs from "@galaxy/modules/Canvas/resources/js/editor/website/editors/inputs/CommonInputs";
import TextInput from "@galaxy/modules/Canvas/resources/js/editor/website/editors/inputs/TextInput";
import SwitchInput from "@galaxy/modules/Canvas/resources/js/editor/website/editors/inputs/SwitchInput";
import AccordionInput from "@galaxy/modules/Canvas/resources/js/editor/website/editors/inputs/helpers/Input";

export default {

    extends: AbstractPanel,

    components: {
        FloatingPanel,
        CommonInputs,
        Tabs,
        TextInput,
        SwitchInput,
        AccordionInput,
    },

    data() {
        return {
            categoriesEnabled: false,
            categories: [],
        };
    },

    mounted() {
        this.fetchStoryCategories();

        // Initialize options if not set
        if (!this.options.categories) {
            this.$set(this.options, 'categories', []);
        }
    },

    methods: {
        async fetchStoryCategories() {
            try {
                const response = await fetch('/api/story-categories');
                const data = await response.json();

                this.categoriesEnabled = data.enabled;
                this.categories = data.categories;
            } catch (error) {
                console.error('Failed to fetch story categories:', error);
            }
        },
    },

}

</script>
